// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1ZZrd","topBottomGutter":"Layout_topBottomGutter__MPoF3"};